var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',[_c('Slides'),_c('QuickLinks'),_c('Specialties'),_c('PagesBanners'),_c('PressRoom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }